import { render } from "./ReuseableModal.vue?vue&type=template&id=b163178a"
import script from "./ReuseableModal.vue?vue&type=script&lang=js"
export * from "./ReuseableModal.vue?vue&type=script&lang=js"
script.render = render

export default script